import { useState } from 'react'
import { FaBell } from 'react-icons/fa6'
import apiClient from '../../../services/apiClient'

export function NotificationComposer({ apiToken, onRefresh } = {}) {
  const [status, setStatus] = useState('')
  const [lastDelivery, setLastDelivery] = useState(null)

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (!apiToken) return

    const formElement = event.currentTarget
    const form = new FormData(formElement)

    try {
      setStatus('Sending notification...')
      const result = await apiClient.sendNotification(apiToken, {
        type: form.get('type'),
        audience: form.get('audience'),
        message: form.get('message') || 'OBC marketplace update',
      })

      setLastDelivery(result)
      formElement.reset()
      setStatus('')
      await onRefresh?.(`Notification sent to ${result.delivered || 0} account${result.delivered === 1 ? '' : 's'}; ${result.skippedByPreference || 0} skipped by preferences`)
    } catch (error) {
      setStatus(error.message || 'Notification failed')
    }
  }

  return (
    <form className="tactical-card obc-admin__builder" onSubmit={handleSubmit}>
      <div className="obc-admin__panel-head">
        <h2>Notification Center</h2>
        <span>Send operational alerts</span>
      </div>
      <div className="obc-admin__notification-templates">
        <article><strong>Outbid</strong><span>Targets users who need to re-enter an auction lane.</span></article>
        <article><strong>Ending</strong><span>Pushes urgency for watched and active auction lots.</span></article>
        <article><strong>Checkout</strong><span>Moves unpaid wins and weekly bundle reminders.</span></article>
      </div>
      <div className="obc-admin__form-grid">
        <label>Alert type<select name="type" defaultValue="outbid"><option value="outbid">Outbid alert</option><option value="auction-ending">Auction ending</option><option value="winning">Winning notice</option><option value="checkout-reminder">Checkout reminder</option><option value="new-drop">New drop</option><option value="admin-announcement">Admin announcement</option></select></label>
        <label>Audience<select name="audience" defaultValue="watchers"><option value="watchers">Watchlist users</option><option value="winning-bidders">Leading / winning bidders</option><option value="all-users">All active users</option><option value="consignors">Linked consignors</option></select></label>
        <label className="is-wide">Message<input name="message" placeholder="Auction ending soon: featured lot closes in 30 minutes." /></label>
      </div>
      <div className="obc-admin__upload-row">
        <button type="submit"><FaBell /> Send Notification</button>
      </div>
      {lastDelivery ? (
        <div className="obc-admin__delivery-result">
          <strong>{lastDelivery.delivered || 0}</strong>
          <span>Delivered to {lastDelivery.audience?.replace(/-/g, ' ') || 'selected audience'} / {lastDelivery.skippedByPreference || 0} skipped by preferences</span>
        </div>
      ) : null}
      {status ? <small className="obc-admin__form-status">{status}</small> : null}
    </form>
  )
}

export function AdminNotificationsModule({ apiToken, onRefresh }) {
  return <NotificationComposer apiToken={apiToken} onRefresh={onRefresh} />
}
